import React from 'react';
import MultiMedia from '../../../containers/Content/Forms/MultiMedia/MultiMedia';

const WrapperComponent = (props) => {


  return (
    <div>
      <MultiMedia {...props} />
    </div>
  );
};

export default WrapperComponent;